__turbopack_context__.v({
  "deleteIcon": "ulpzfa_deleteIcon",
  "isDeletable": "ulpzfa_isDeletable",
  "isReadonly": "ulpzfa_isReadonly",
  "isSelected": "ulpzfa_isSelected",
  "nice": "ulpzfa_nice",
  "withLimitedWidth": "ulpzfa_withLimitedWidth",
  "withNice": "ulpzfa_withNice",
  "word": "ulpzfa_word",
});
